import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as $ from 'jquery'
import 'chart.js'

import './component.scss'
import './images/fuki_icon01_01.png'

// ルートクラス定義
const ROOT_TARGET_CLASS_NAME = 'js-companyEvaluation-root-target'
const ROOT_TARGET_SELECTOR = `.${ROOT_TARGET_CLASS_NAME}`

const companyEvaluationDetailRadarChart = () => {
  // セレクタ定義
  const SPIDER_CHART_TARGET_CLASS_NAME = 'js-companyEvaluation-detail-radarChart-target'
  const SPIDER_CHART_TARGET_SELECTOR = `.${SPIDER_CHART_TARGET_CLASS_NAME}`

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $radarChartTarget = $(root).find(SPIDER_CHART_TARGET_SELECTOR)
    const chartDataset = $radarChartTarget.data('chart')
    const { labels, dataByClient, dataByPrefecture, clientName } = chartDataset

    // labelを加工
    const formattedLabels = labels.map((label) => {
      return {
        '業者（担当者）の対応の良さ': '業者（担当者）の対応',
        '提案内容の的確さ・幅広さ': '提案内容',
        '価格・費用の納得感': '価格・費用',
        施工スケジュールの納得感: '施工スケジュール'
      }[label] || label
    })

    const datasets = [{
      label: clientName,
      data: dataByClient,
      fill: true,
      backgroundColor: 'rgb(249,218,112, 0.4)',
      borderColor: 'rgb(249,218,112, 0.7)'
    }]

    let displayLegend = false

    if (dataByPrefecture.length) {
      datasets.push({
        label: 'エリア平均',
        data: dataByPrefecture,
        fill: true,
        backgroundColor: 'rgba(112, 173, 249, 0.4)',
        borderColor: 'rgba(112, 173, 249, 0.7)'
      })
      displayLegend = true
    }

    new Chart($radarChartTarget, {
      type: 'radar',
      data: {
        labels: formattedLabels,
        datasets: datasets
      },
      options: {
        scale: {
          ticks: {
            display: false,
            min: 0,
            max: 5,
            stepSize: 1
          }
        },
        legend: {
          display: displayLegend
        },
        title: {
          display: false
        }
      }
    })
  })
}

$(() => {
  // 評価詳細のレーダーチャート処理
  companyEvaluationDetailRadarChart()
})
